import { AUTH_CLIENT_ID, AUTH_ENDPOINT } from "@/constants";
import jsSHA from "jssha";

export default class AuthHelper {
  static get endpoint(): string {
    return AUTH_ENDPOINT + "/oauth";
  }

  static get clientID(): string {
    return AUTH_CLIENT_ID;
  }

  static get redirectUri(): string {
    return location.origin + "/auth";
  }

  generateRandomString(): string {
    const array = new Uint32Array(28);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => ("0" + dec.toString(16)).substr(-2)).join(
      ""
    );
  }

  sha256(plain: string): ArrayBuffer {
    const shaObj = new jsSHA("SHA-256", "TEXT");
    shaObj.update(plain);
    return shaObj.getHash("ARRAYBUFFER");
  }

  base64encode(buffer: ArrayBuffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  }

  pkceChallengeFromVerifier(verifier: string) {
    const hashed = this.sha256(verifier);
    return this.base64encode(hashed);
  }

  generateAuthorizeUri(codeVerifier: string) {
    const challengeCode = this.pkceChallengeFromVerifier(codeVerifier);
    const params = new URLSearchParams({
      client_id: AuthHelper.clientID,
      redirect_uri: AuthHelper.redirectUri,
      code_challenge_method: "S256",
      code_challenge: challengeCode,
      response_type: "code",
      scope: "read",
    });

    return AuthHelper.endpoint + "/authorize?" + params.toString();
  }

  getLogoutUri(): string {
    return AUTH_ENDPOINT + "/logout";
  }
}
